import { IngredientDetail } from './IngredientDetail';
import { useGetSupplementDetailQuery } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';
import { useParams } from 'react-router-dom';
import { IngredientDetailSkeleton } from './IngredientDetailSkeleton';
import { ErrorLoadingPage } from '../ErrorHandling/ErrorLoadingPage';

// TODO: Change to S3 url
const IMG_URL =
  'https://res.cloudinary.com/dsf1qebes/image/upload/v1733774101/david-becker-rrfdqjJWwmU-unsplash_u3ggse.png';

export const IngredientDetailPage = () => {
  const { id: ingredientId } = useParams();

  const { data, isLoading, isError } = useGetSupplementDetailQuery({
    ingredient_id: Number(ingredientId),
  });

  const {
    description,
    related_researches: relatedSearches,
    scores,
    title,
    badges = [],
    dosage_with_unit: dosageWithUnit,
    group_name: groupName,
    product_id: productId,
  } = data || {};

  const validScores = scores || [];

  if (isLoading) {
    return <IngredientDetailSkeleton />;
  }

  if (isError) {
    return <ErrorLoadingPage />;
  }

  return (
    <div
      className="relative bg-cover bg-center"
      style={{
        backgroundImage: `url(${IMG_URL})`,
      }}
    >
      <IngredientDetail
        title={title}
        description={description}
        dosageWithUnit={dosageWithUnit}
        groupName={groupName}
        subDescriptionLabel=""
        helperCards={badges}
        scoreCards={validScores}
        supportingResearch={relatedSearches}
        ingredientId={ingredientId}
        productId={productId}
      />
    </div>
  );
};
